module.exports = __webpack_public_path__ + "static/media/3840x2160.0826051e.jpg";